module.exports = __webpack_public_path__ + "static/img/tu11.1678b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/tu11.png
// module id = ZUmx
// module chunks = 1